const WalkingDark = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none">
    <path
      d="M1.15 3.6L2.75 2.45C2.95 2.3 3.15 2.25 3.35 2.25C3.9 2.25 4.4 2.65 4.55 3.15C4.65 3.45 4.75 3.65 4.8 3.75C5.25 4.4 6 4.75 6.8 4.75V5.75C5.75 5.75 4.75 5.3 4.1 4.5L3.75 6.5L4.8 7.35L5.9 10.4L4.95 10.75L3.95 7.95L2.25 6.55C1.95 6.3 1.85 5.95 1.9 5.6L2.15 4.15L1.85 4.35L0.8 5.8L0 5.2L1.15 3.6ZM4.1 2C3.55 2 3.1 1.55 3.1 1C3.1 0.45 3.55 0 4.1 0C4.65 0 5.1 0.45 5.1 1C5.1 1.55 4.65 2 4.1 2ZM2.6 8.6L1 10.5L0.25 9.85L1.75 8.1L2.1 7L3 7.75L2.6 8.6Z"
      fill="#374151"
    />
  </svg>
);

export default WalkingDark;
